<template>
  <div class="p-inputgroup">
    <AutoComplete 
      :modelValue="modelValue" 
      :suggestions="suggestions" 
      field="nombre"
      @complete="buscarCliente($event)"
      @update:modelValue="$emit('update:modelValue', $event)"
      @item-select="alSeleccionarCliente($event.value)"
      :placeholder="placeholder" 
      class="p-inputtext-sm w-full"
      inputClass="w-full"
      forceSelection
    >
      <template #item="slotProps">
        <div class="font-bold text-sm">
          {{ slotProps.item.nombre }} <span v-if="slotProps.item.nit">- {{ slotProps.item.nit }}</span>
        </div>
      </template>
    </AutoComplete>
    <!-- Opcional: Si quieres mantener el botón de nuevo cliente dentro del componente -->
    <Button
      v-if="mostrarBotonNuevo"
      icon="pi pi-user-plus"
      class="p-button-primary p-button-sm"
      style="width: 2.5rem;"
      v-tooltip.top="'Nuevo Cliente'"
      @click="$emit('nuevoCliente')"
    />
  </div>
</template>

<script>
import ClienteService from '@/service/ClienteService';

export default {
  name: 'SearchCliente',
  props: {
    modelValue: {
      type: [Object, String, null],
      default: null
    },
    placeholder: {
      type: String,
      default: 'Buscar por Nombre'
    },
    mostrarBotonNuevo: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'cliente-seleccionado', 'nuevoCliente'],
  data() {
    return {
      suggestions: [],
      clienteService: new ClienteService(),
      timeoutDebounce: null
    }
  },
  methods: {
    buscarCliente(event) {
      // Usamos un pequeño retraso (debounce) para no saturar el backend con cada tecla que presiona el usuario
      clearTimeout(this.timeoutDebounce);
      this.timeoutDebounce = setTimeout(async () => {
        try {
          // Asumimos que el backend espera un objeto con 'texto' o 'nombre'
          const response = await this.clienteService.buscarXNombre({ texto: event.query });
          
          let data = Array.isArray(response) 
            ? response 
            : (response.data || response.clientes || Object.values(response).find(Array.isArray) || []);
            
          this.suggestions = data;
        } catch (error) {
          console.error("Error al buscar cliente:", error);
          this.suggestions = [];
        }
      }, 300);
    },
    alSeleccionarCliente(clienteSeleccionado) {
      // Emitimos el evento extra por si el componente padre necesita saber que se seleccionó un cliente
      this.$emit('cliente-seleccionado', clienteSeleccionado);
    }
  }
}
</script>

<style scoped>
</style>
